export const Roles = {
  SuperAdmin: "SuperAdmin",
  Admin: "Admin",
  Operator: "Operator",
  Regulator: "Regulator",
  Investor: "Investor",
};

export const RouteAccess = {
  AdminOnly: [Roles.SuperAdmin, Roles.Admin],
  LookupAccess: [Roles.SuperAdmin, Roles.Admin, Roles.Operator],
  CoreAccess: [Roles.SuperAdmin, Roles.Admin, Roles.Operator, Roles.Regulator],
};

export function getUserInfo() {
  try {
    return JSON.parse(localStorage.getItem("userInfo")) || {};
  } catch (e) {
    return {};
  }
}

export function getUserRole() {
  const user = getUserInfo();
  return user.userType || user.UserType || "";
}

export function hasRole(role) {
  return getUserRole() === role;
}

export function hasAnyRole(roles) {
  return roles.indexOf(getUserRole()) !== -1;
}

export function canViewAdminMenu() {
  return hasAnyRole(RouteAccess.CoreAccess);
}

export function canViewLookups() {
  return hasAnyRole(RouteAccess.LookupAccess);
}

export function canViewCorePages() {
  return hasAnyRole(RouteAccess.CoreAccess);
}

export function canViewUserManagement() {
  return hasAnyRole(RouteAccess.AdminOnly);
}

export function isReadOnlyUser() {
  return hasRole(Roles.Regulator);
}

export function canAdd() {
  return hasAnyRole(RouteAccess.AdminOnly);
}

export function canEdit() {
  return hasAnyRole([Roles.SuperAdmin, Roles.Admin, Roles.Operator]);
}

export function canDelete() {
  return hasAnyRole(RouteAccess.AdminOnly);
}

export function canApprove() {
  return hasAnyRole(RouteAccess.AdminOnly);
}

export function canChangeStatus() {
  return hasAnyRole(RouteAccess.AdminOnly);
}
